import React from 'react';
import { Context } from '../LocaleWrapper';
import styles from './BackgroundImage.module.css';

const MEDIA_QUERIES = {
  desktop: '992',
  tablet: '520',
  default: '0',
};

type MediaQuery = 'desktop' | 'tablet' | 'default';

interface Props {
  images: {
    [key: string]: string;
  };
}
export function BackgroundImage(props: Props): React.ReactElement {
  const { images } = props;
  const { getMediaUri } = React.useContext(Context);

  // TODO: Check a way to always show an image
  function getCss(
    url: string,
    mediaQuery: MediaQuery,
    getMediaUri: (url: string) => string
  ): string {
    const regExp = new RegExp('^http');
    const urlHasProtocol = regExp.test(url);
    const imageUrl = urlHasProtocol ? url : getMediaUri(url);
    const backgroundImageClass = `
      .${styles.image} {
        background-image: url(${imageUrl});
      }
    `;

    return `
      @media (min-width: ${MEDIA_QUERIES[mediaQuery]}px) {
        ${backgroundImageClass}
      }`;
  }

  function getImageStyle(
    getMediaUri: (url: string) => string,
    acc: string,
    key: MediaQuery,
    value: string
  ): string {
    if (!value) {
      return acc;
    }

    return acc + getCss(value, key, getMediaUri);
  }

  const backgroundStyles = Object.keys(images).reduce(
    (acc: string, key) =>
      getImageStyle(getMediaUri, acc, key as MediaQuery, images[key]),
    ''
  );

  return (
    <div className={styles.wrapper}>
      <style>{backgroundStyles}</style>
      <div className={styles.image} />
    </div>
  );
}
